import React, { useContext, useEffect, forwardRef, useState } from "react";

import { Grid, List, Typography, Card } from "@material-ui/core";

import MaterialTable, {
  MTableToolbar,
  MTablePagination,
  MTableBody,
  MTableHeader,
} from "material-table";

import {
  AddBox,
  ArrowDownward,
  Check,
  ChevronLeft,
  ChevronRight,
  Clear,
  DeleteOutline,
  Edit,
  FilterList,
  FirstPage,
  LastPage,
  Remove,
  SaveAlt,
  Search,
  ViewColumn,
} from "@material-ui/icons";

import { makeStyles } from "@material-ui/core/styles";

import DeleteIcon from "@material-ui/icons/Delete";

import FulfillmentContext from "../../context/fulfillment/FulfillmentContext";

const FulfillmentTable = ({ rows, setRows, dateRange, columnList }) => {
  const fulfillmentContext = useContext(FulfillmentContext);
  const { unfulfill, unfulfillAdded } = fulfillmentContext;

  const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => (
      <ChevronRight {...props} ref={ref} />
    )),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => (
      <ChevronLeft {...props} ref={ref} />
    )),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => (
      <ArrowDownward {...props} ref={ref} />
    )),
    ThirdStateCheck: forwardRef((props, ref) => (
      <Remove {...props} ref={ref} />
    )),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
  };

  const useStyles = makeStyles((theme) => ({
    list: {
      backgroundColor: "#FDFDFD",
      position: "relative",
      overflow: "auto",
      width: "100%",
      height: 600,
    },
  }));

  const classes = useStyles();

  //set rows data
  useEffect(() => {
    if (unfulfill && unfulfill.length > 0) {
      setRows([]);
      for (let x in unfulfill) {
        setRows((rows) => [
          ...rows,
          {
            store_name: unfulfill[x].store_name,
            order_id: unfulfill[x].order_id,
            sku: unfulfill[x].sku,
            quantity: unfulfill[x].quantity,
            total_quantity: unfulfill[x].total_quantity,
            amount: unfulfill[x].amount,
            product_name: unfulfill[x].product_name,
            variant_title: unfulfill[x].variant_title,
            name: unfulfill[x].name,
            address: unfulfill[x].address,
            city: unfulfill[x].city,
            province: unfulfill[x].province,
            country: unfulfill[x].country,
            zip: unfulfill[x].zip,
            phone: unfulfill[x].phone,
            email: unfulfill[x].email,
            date_ordered: unfulfill[x].date_ordered,
            shipping_cost: unfulfill[x].shipping_cost,
            product_cost: unfulfill[x].product_cost,
          },
        ]);
      }
    }
    // eslint-disable-next-line
  }, [unfulfill]);

  // Add Row
  useEffect(() => {
    if (unfulfillAdded && unfulfillAdded.length > 0) {
      for (let x in unfulfillAdded) {
        setRows((rows) => [
          ...rows,
          {
            store_name: unfulfillAdded[x].store_name,
            order_id: unfulfillAdded[x].order_id,
            sku: unfulfillAdded[x].sku,
            quantity: unfulfillAdded[x].quantity,
            total_quantity: unfulfillAdded[x].total_quantity,
            amount: unfulfillAdded[x].amount,
            product_name: unfulfillAdded[x].product_name,
            variant_title: unfulfillAdded[x].variant_title,
            name: unfulfillAdded[x].name,
            address: unfulfillAdded[x].address,
            city: unfulfillAdded[x].city,
            province: unfulfillAdded[x].province,
            country: unfulfillAdded[x].country,
            zip: unfulfillAdded[x].zip,
            phone: unfulfillAdded[x].phone,
            email: unfulfillAdded[x].email,
            date_ordered: unfulfillAdded[x].date_ordered,
            shipping_cost: unfulfillAdded[x].shipping_cost,
            product_cost: unfulfillAdded[x].product_cost,
          },
        ]);
      }
    }
    // eslint-disable-next-line
  }, [unfulfillAdded]);

  const handleDeleteRows = (event, rowData) => {
    let data = [...rows];
    rowData.forEach((row) => {
      data = data.filter((t) => t.tableData.id !== row.tableData.id);
    });
    setRows([...data]);
  };

  const [paginationProps, setPaginationProps] = useState("");

  return (
    <Grid container direction="row" justifyContent="center">
      <Grid
        item
        style={{
          width: "100%",
        }}
      >
        <Card
          style={{
            width: "100%",
          }}
        >
          <Grid
            container
            direction="row"
            justifyContent="flex-end"
            style={{
              width: "100%",
            }}
          >
            <Grid item xs={12}>
              <List className={classes.list}>
                <MaterialTable
                  columns={columnList}
                  data={rows}
                  icons={tableIcons}
                  components={{
                    Toolbar: (props) => (
                      <Grid
                        container
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                      >
                        <Grid
                          item
                          style={{
                            marginLeft: 5,
                          }}
                        >
                          <Typography variant="h5"> {dateRange} </Typography>{" "}
                        </Grid>{" "}
                        <Grid item>
                          <MTableToolbar {...props} />{" "}
                        </Grid>{" "}
                      </Grid>
                    ),
                    Pagination: (props) => {
                      if (!paginationProps && props.count !== 0) {
                        setPaginationProps(props);
                      } else if (paginationProps) {
                        if (paginationProps.page !== props.page) {
                          setPaginationProps(props);
                        }
                      }
                      return <Grid> </Grid>;
                    },
                  }}
                  actions={[
                    {
                      icon: () => <DeleteIcon />,
                      tooltip: "Delete Rows",
                      onClick: handleDeleteRows,
                    },
                  ]}
                  options={{
                    search: true,
                    paging: true,
                    pageSizeOptions: [10, 25, 50],
                    pageSize: 10,
                    toolbar: true,
                    sorting: false,
                    showTitle: false,
                    padding: "dense",
                    draggable: false,
                    selection: true,
                    headerStyle: {
                      fontWeight: "bold",
                      fontSize: 12,
                      textAlign: "center",
                      zIndex: 0,
                    },
                  }}
                />{" "}
              </List>{" "}
            </Grid>{" "}
            <Grid
              item
              style={{
                width: 400,
              }}
            >
              {" "}
              {paginationProps ? (
                <MTablePagination {...paginationProps} />
              ) : null}{" "}
            </Grid>{" "}
          </Grid>{" "}
        </Card>{" "}
      </Grid>{" "}
    </Grid>
  );
};

export default FulfillmentTable;
